/* eslint-disable react/react-in-jsx-scope */
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { routePaths } from '../../routes/routes-path';
import { LocalStorageService } from '../../configuration';

const PrivateRoute = () => {
  const isLogged = LocalStorageService.getItem('accessToken');
  const location = useLocation();

  if (!isLogged) {
    // Nhớ đích đến để sau khi đăng nhập quay lại đúng trang (vd người ngoài bấm "Đăng ký Publisher" → /publisher).
    try { sessionStorage.setItem('postLoginRedirect', location.pathname + location.search); } catch { /* noop */ }
    return <Navigate replace to={routePaths.login} />;
  }

  return <Outlet />;
};

export default PrivateRoute;
